const config = {
 apiBaseUrl: 'https://backend.smartinvestment.info',
 optionBaseURL:"wss://option.smartinvestment.info",
 websocketBaseURL:"wss://real-time.smartinvestment.info",
 // apiBaseUrl: 'http://localhost:8001'
};

export default config;
